import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188f3da4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = { class: "job-listing-area pt-120 mb-120" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row g-lg-4 gy-5" }
const _hoisted_9 = { class: "col-lg-12 order-lg-2 order-1" }
const _hoisted_10 = {
  key: 0,
  class: "table-wrapper2"
}
const _hoisted_11 = { class: "table-filter-area mb-30" }
const _hoisted_12 = { class: "form-wrap style-2 style-3 employer-search-reponsive-filter" }
const _hoisted_13 = { class: "form-inner jobseeker-filter-1" }
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/search-2.svg",
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "form-inner jobseeker-filter-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Availability", -1))
const _hoisted_18 = ["value", "selected"]
const _hoisted_19 = { class: "form-inner jobseeker-filter-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Location", -1))
const _hoisted_21 = ["value", "selected"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "primry-btn-1"
}, "Search", -1))
const _hoisted_23 = { class: "job-listing-wrrap" }
const _hoisted_24 = {
  key: 0,
  class: "p-3 mb-3 contact-seeker-panel container"
}
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6 wp-bulk-selection" }
const _hoisted_27 = {
  key: 0,
  class: "col-lg-6 wp-bulk-option"
}
const _hoisted_28 = {
  key: 1,
  class: "row"
}
const _hoisted_29 = {
  key: 0,
  class: "p-5"
}
const _hoisted_30 = { class: "d-flex justify-content-center py-5" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "job-top jon-top-mr-b" }
const _hoisted_33 = { class: "job-list-content" }
const _hoisted_34 = { class: "company-area d-flex flex-column justify-content-between gap-3" }
const _hoisted_35 = { class: "logo" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "company-details" }
const _hoisted_38 = { class: "name-location" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "job-discription" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Designation:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Location:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Qualification:", -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Summary:", -1))
const _hoisted_47 = { class: "d-flex flex-column justify-content-between gap-3" }
const _hoisted_48 = { class: "col-lg-12 d-flex justify-content-center" }
const _hoisted_49 = {
  key: 2,
  class: "row"
}
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = { class: "form-wrapper" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Message"),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1))
const _hoisted_53 = { class: "profile-form" }
const _hoisted_54 = { class: "section-title2" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "form-inner mb-25" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "Message *", -1))
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "form-inner" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = {
  key: 3,
  class: "row"
}
const _hoisted_68 = { class: "col-12" }
const _hoisted_69 = { class: "form-wrapper" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title text-center" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Send Email "),
  /*#__PURE__*/_createElementVNode("div", { class: "dash" })
], -1))
const _hoisted_71 = { class: "profile-form" }
const _hoisted_72 = { class: "section-title2" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = { class: "col-md-12" }
const _hoisted_75 = { class: "form-inner mb-25" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "subject" }, "Subject *", -1))
const _hoisted_77 = { class: "input-area" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/icon/company-2.svg",
  alt: ""
}, null, -1))
const _hoisted_79 = { class: "col-md-12" }
const _hoisted_80 = { class: "form-inner mb-25" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mailBody" }, "Message Body*", -1))
const _hoisted_82 = { class: "col-md-12" }
const _hoisted_83 = { class: "form-inner" }
const _hoisted_84 = {
  key: 1,
  class: "primry-btn-2 lg-btn w-unset",
  type: "button"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white ms-3",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_87 = [
  _hoisted_85,
  _hoisted_86
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Employee Directory", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.filterVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("form", {
                      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.filterSeeker && _ctx.filterSeeker(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery.keyword) = $event)),
                              placeholder: "Search"
                            }, null, 512), [
                              [_vModelText, _ctx.searchQuery.keyword]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery.availability_id) = $event))
                          }, [
                            _hoisted_17,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employeeAvailabilityList, (availability) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: availability.id,
                                selected: _ctx.searchQuery.availability_id == availability.id
                              }, _toDisplayString(availability.name), 9, _hoisted_18))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.searchQuery.availability_id]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery.location_id) = $event))
                          }, [
                            _hoisted_20,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsOptions, (location) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: location.id,
                                selected: _ctx.searchQuery.location_id == location.id
                              }, _toDisplayString(location.name), 9, _hoisted_21))
                            }), 256))
                          ], 512), [
                            [_vModelSelect, _ctx.searchQuery.location_id]
                          ])
                        ]),
                        _hoisted_22
                      ])
                    ], 32)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.bulkContainer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          class: _normalizeClass([{ 'bulkselection-active': _ctx.bulkSelectionBtn }, "primry-btn-2 p-1 px-3 me-2 d-inline-block"]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bulkSelection()))
                        }, "Bulk Selection ", 2)
                      ]),
                      (_ctx.selectedSeekers.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("button", {
                              class: "primry-btn-2 p-1 px-3 me-2 d-inline-block",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openForm(_ctx.selectedSeekersInfo)))
                            }, "Send Sms"),
                            _createElementVNode("button", {
                              class: "primry-btn-2 p-1 px-3 d-inline-block",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openMailForm(_ctx.selectedSeekersInfo)))
                            }, "Send Email")
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showForm && !_ctx.mailFormShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    (_ctx.pageLoading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_ProgressSpinner)
                          ])
                        ]))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.jobSeekers, (seeker) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: seeker.id,
                            class: "col-lg-12 mb-30"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["job-listing-card", {
                                        'selected-seekers': _ctx.selectedSeekers.includes(seeker.id),
                                        'contact-seeker-card': _ctx.bulkSelectionVar
                                    }]),
                              onClick: ($event: any) => (_ctx.toggleSeekerSelection(seeker, seeker.id, _ctx.bulkSelectionVar))
                            }, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("img", {
                                          src: (seeker.photo) ? seeker.photo : 'https://loremflickr.com/52/52/logo,organisation/all',
                                          alt: ""
                                        }, null, 8, _hoisted_36)
                                      ]),
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _createVNode(_component_router_link, {
                                            to: 'job-seeker/' + seeker.id
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h5", null, _toDisplayString(seeker.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("button", {
                                        class: "primry-btn-2 p-1 px-3 me-2 d-inline-block",
                                        onClick: ($event: any) => (_ctx.openForm(seeker))
                                      }, "Send Sms", 8, _hoisted_39),
                                      _createElementVNode("button", {
                                        class: "primry-btn-2 p-1 px-3 d-inline-block",
                                        onClick: ($event: any) => (_ctx.openMailForm(seeker))
                                      }, "Send Email", 8, _hoisted_40)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("ul", null, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("p", null, [
                                          _hoisted_42,
                                          _createTextVNode(" " + _toDisplayString(seeker.designtion?.name ?? 'No Designation'), 1)
                                        ])
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("p", null, [
                                          _hoisted_43,
                                          _createTextVNode(" " + _toDisplayString(seeker.job_location?.name ?? 'No Location'), 1)
                                        ])
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("p", null, [
                                          _hoisted_44,
                                          _createTextVNode(" " + _toDisplayString(seeker.qualification?.name ?? 'No Qualification'), 1)
                                        ])
                                      ]),
                                      (seeker.description)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                            _createElementVNode("p", null, [
                                              _hoisted_46,
                                              _createTextVNode(" " + _toDisplayString(seeker.description.length > 100 ?
                                                                    seeker.description.substring(0, 75) + '...' :
                                                                    seeker.description), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_47, [
                                  _createTextVNode("Total reviews: (" + _toDisplayString(seeker.reviews.length) + ") ", 1),
                                  _createVNode(_component_router_link, {
                                    to: 'job-seeker/' + seeker.id,
                                    class: "router-link-active active primry-btn-1 hover-white user-btn-custom py-2 px-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Detail Job Seeker ")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ])
                              ])
                            ], 10, _hoisted_31)
                          ]))
                        }), 128)),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_component_Paginator, {
                        first: _ctx.currentPage,
                        "onUpdate:first": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentPage) = $event)),
                        rows: _ctx.rowsPerPage,
                        totalRecords: _ctx.totalPages,
                        onPage: _ctx.handlePageChange
                      }, null, 8, ["first", "rows", "totalRecords", "onPage"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showForm)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("form", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("h5", null, "To: " + _toDisplayString(_ctx.smsForm.full_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.smsForm.message) = $event)),
                                  id: "message",
                                  placeholder: "Message",
                                  disabled: _ctx.smsForm.last_four == null
                                }, null, 8, _hoisted_59), [
                                  [_vModelText, _ctx.smsForm.message]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "primry-btn-2 lg-btn w-unset",
                                      type: "button",
                                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                                      disabled: _ctx.smsForm.last_four == null
                                    }, "Send SMS", 8, _hoisted_62))
                                  : _createCommentVNode("", true),
                                (_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", _hoisted_63, _hoisted_66))
                                  : _createCommentVNode("", true),
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: "primry-btn-2 lg-btn w-unset float-end",
                                      type: "button",
                                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                                    }, "Cancel"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.mailFormShow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _hoisted_70,
                        _createElementVNode("form", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("h5", null, "To: " + _toDisplayString(_ctx.mailForm.full_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("div", _hoisted_77, [
                                  _hoisted_78,
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.mailForm.subject) = $event)),
                                    type: "text",
                                    id: "subject",
                                    name: "subject"
                                  }, null, 512), [
                                    [_vModelText, _ctx.mailForm.subject]
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _hoisted_81,
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.mailForm.body) = $event)),
                                  id: "mailBody",
                                  placeholder: "Write here..."
                                }, null, 512), [
                                  [_vModelText, _ctx.mailForm.body]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", _hoisted_83, [
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "primry-btn-2 lg-btn w-unset",
                                      type: "button",
                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.sendEmail && _ctx.sendEmail(...args)))
                                    }, "Send Mail"))
                                  : (_openBlock(), _createElementBlock("button", _hoisted_84, _hoisted_87)),
                                (!_ctx.isLoading)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: "primry-btn-2 lg-btn w-unset float-end",
                                      type: "button",
                                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeMailForm && _ctx.closeMailForm(...args)))
                                    }, "Cancel"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}